import { Stack, Typography } from '@mui/material';
import { useMemo } from 'react';

import { tCommon } from '@frontend/locales';
import { resolvePlaceDisplayNames, useShopContext } from '@frontend/utils';

export interface FilterPlacesProps {
  placeIds: string[] | undefined;
}

export const FilterPlaces = ({ placeIds }: FilterPlacesProps) => {
  const { shop } = useShopContext();

  const placeNames = useMemo(
    () =>
      resolvePlaceDisplayNames(
        placeIds,
        shop.places,
        tCommon.actions.allPlaces(),
      ),
    [shop, placeIds],
  );

  return (
    <Stack direction="row" columnGap={0.5} alignItems="center">
      {placeNames.map((placeName) => (
        <Typography key={placeName} variant="caption">
          {placeName}
        </Typography>
      ))}
    </Stack>
  );
};
